export default [
  { name: 'id', label: 'ID', type: 'immutable' },
  { name: 'hostname', label: 'Hostname' },
  { name: 'name', label: 'Name' },
  { name: 'product.name', label: 'Product', type: 'immutable' }
]



// WEBPACK FOOTER //
// ./src/fields/servers.js